import { render, staticRenderFns } from "./MultipleServiceConfig.vue?vue&type=template&id=d20ea8a4&scoped=true"
import script from "./MultipleServiceConfig.vue?vue&type=script&lang=js"
export * from "./MultipleServiceConfig.vue?vue&type=script&lang=js"
import style0 from "./MultipleServiceConfig.vue?vue&type=style&index=0&id=d20ea8a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20ea8a4",
  null
  
)

export default component.exports